import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import useBundleCourse from './useBundleCourse';

import { BundleCoursesEntity } from '@redux/bundle/type/BundleDetailType';
import { RootState } from '@redux/reducer';

const useBundleCourseItemsModal = () => {
  const { handleFetchCourseDetailSeo, handleFetchCourseDetail, handleFetchCourseDetailGlance } = useBundleCourse();
  const [currentIndex, setCurrentIndex] = useState<number>(NaN);
  const { bundleCoursesState } = useSelector((state: RootState) => ({
    bundleCoursesState: state.Bundle.get('bundleCoursesState'),
  }));

  const { data: bundleCoursesData } = bundleCoursesState;

  const findIndexByIdName = (array: BundleCoursesEntity, idName: string) => {
    const index = array.findIndex((item) => item.idName === idName);
    return index;
  };

  const setCurrentCourseIndex = useCallback(
    (idName: string) => {
      const index = findIndexByIdName(bundleCoursesData, idName);
      setCurrentIndex(index);
    },
    [bundleCoursesData],
  );

  const isCourseEnrolledByIdName = (idName: string) => {
    const courseIndex = findIndexByIdName(bundleCoursesData, idName);
    return bundleCoursesData[courseIndex]?.isEnrolled;
  };

  const handleFetchCourse = (courseIdName: string) => {
    handleFetchCourseDetailSeo(courseIdName);
    handleFetchCourseDetail(courseIdName);
    handleFetchCourseDetailGlance(courseIdName);
  };

  return {
    currentIndex,
    setCurrentIndex,
    setCurrentCourseIndex,
    handleFetchCourse,
    isCourseEnrolledByIdName,
  };
};

export default useBundleCourseItemsModal;
